module.exports = __webpack_public_path__ + "static/media/illu-header-clea.e619c418.png";